import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { channels } from '@/data/channels';

/**
 * 顶栏。首屏上是透明的，滚过一屏后落到面板色上，避免压住画布读数。
 *
 * 案例页也用这一根顶栏，所以通道链接要分两种走法：在首页上用原生锚点（浏览器
 * 自己滚），在子页上用 Link 跳回 `/#id`——Home 挂载时那次 scrollIntoView 会接住。
 * 写死 `#id` 的话在 `/cases/*` 上点了什么都不会发生。
 */
export default function RackNav() {
  const [solid, setSolid] = useState(false);
  const home = useLocation().pathname === '/';

  useEffect(() => {
    const onScroll = () => setSolid(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const cls =
    'text-rack-bone/45 transition-colors hover:text-rack-bone focus-visible:text-rack-bone focus-visible:outline-none';

  const jump = (id: string, label: string, extra = '') =>
    home ? (
      <a key={id} href={`#${id}`} className={`${cls} ${extra}`}>
        {label}
      </a>
    ) : (
      <Link key={id} to={`/#${id}`} className={`${cls} ${extra}`}>
        {label}
      </Link>
    );

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        solid
          ? 'border-b border-rack-bone/[0.08] bg-rack-ground/92 backdrop-blur-md'
          : 'border-b border-transparent'
      }`}
    >
      <nav
        className="mx-auto flex max-w-[1180px] items-center justify-between gap-4 px-6 py-4 sm:px-10"
        aria-label="主导航"
      >
        <Link to="/" className="flex shrink-0 items-center gap-2.5 text-[13px] font-semibold text-rack-bone">
          <img
            src="/brand/avatar.webp"
            alt=""
            width={26}
            height={26}
            className="h-[26px] w-[26px] rounded-[3px] border border-rack-bone/15 object-cover"
          />
          阳仔AI
        </Link>

        <div className="flex items-center gap-4 text-[11.5px] tracking-[0.04em] sm:gap-6">
          {channels.map((c) => jump(c.id, c.name))}
          <span className="hidden text-rack-bone/12 sm:inline">·</span>
          {jump('about', '关于', 'hidden sm:inline')}
          {jump('contact', '联系')}
        </div>

        <span className="hidden font-readout text-[10px] tracking-[0.18em] text-rack-bone/22 lg:inline">
          SOLO / 2026
        </span>
      </nav>
    </header>
  );
}
